import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import HttpApi from 'i18next-http-backend';
import languageSettings from './configs/language';

i18n.use(HttpApi).use(initReactI18next).init(languageSettings);

export default i18n;